import React from 'react';

import { Box, Typography } from '@mui/material';
import { visuallyHidden } from '@mui/utils';

import { ClearVerifyLogoWhite } from 'src/components/common';
import type { SxProp } from 'src/types/mui';

export const Sidebar: React.FC = () => {
  return (
    <Box component="aside" sx={sidebarStyles}>
      <Typography component="h1" sx={visuallyHidden}>
        Clear Verify
      </Typography>

      <ClearVerifyLogoWhite />

      <Typography variant="body2" sx={topTextStyles}>
        Employment & Income Verifications, Simplified.
      </Typography>

      <Typography variant="body2" sx={bottomTextStyles}>
        Trusted Accuracy, Instantly Delivered.
      </Typography>
    </Box>
  );
};

const sidebarStyles: SxProp = theme => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  p: 2,

  color: 'white',

  backgroundColor: theme.palette.primary.main,

  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
});

const topTextStyles: SxProp = theme => ({
  mt: 2,
  fontSize: '40px',
  lineHeight: 1.2,
  fontWeight: 500,

  [theme.breakpoints.down('md')]: {
    fontSize: '40px',
  },
});

const bottomTextStyles: SxProp = {
  mt: 3,
  fontSize: '16px',
  lineHeight: 1.2,
  fontWeight: 400,
};
